import SubcompanyList from "../components/subcompany/SubcompanyCrud";

const SubcompanyCrudPage = () => {
  return (
    <>
      <SubcompanyList />
    </>
  );
};

export default SubcompanyCrudPage;
